import authReducer from '../screens/auth/login/reducer';
import languageReducer from '../translation/reducer';
import loadingReducer from '../connected-components/loading/reducer';
import toastReducer from '../connected-components/toast/reducer';
import filtersModalReducer from '../connected-components/filtersModal/reducer';
import globalModalReducer from '../connected-components/globalModal/reducer';
import languagePickerModalReducer from '../connected-components/languagePickerModal/reducer';
import settingsReducer from '../screens/content/settings/reducer';
import filtersReducer from '../screens/content/home/reducer';
import homeTabsReducer from '../screens/content/customizeHome/reducer';
import drawerReducer from '../connected-components/drawer/reducer';
import onboardingReducer from '../screens/auth/onboarding/reducer';
import chatReducer from '../screens/content/chat/reducer';

export default {
  auth: authReducer,
  lang: languageReducer,
  loading: loadingReducer,
  toast: toastReducer,
  filtersModal: filtersModalReducer,
  globalModal: globalModalReducer,
  settings: settingsReducer,
  languagePickerModal: languagePickerModalReducer,
  filters: filtersReducer,
  homeTabs: homeTabsReducer,
  drawer: drawerReducer,
  onboarding: onboardingReducer,
  chat: chatReducer,
};
